import React from "react";

import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";

import { GridContentDashboard } from "../components/CustomGrids";
import AddProjectStepper from "../components/AddProjectStepper";
import { CssBox, CssButton, CssTextField } from "../components/StyledComponent";

import { addTitle } from "../../../store/features/Project";

const styles = {
  titleInput1: {
    color: "#46bda7",
    fontWeight: "lighter",
  },
  subtitleInput1: {
    fontWeight: "bolder",
    color: "#002f4f",
  },
  cssLink: {
    textDecoration: "none",
  },
  typoMenuLeft1: {
    color: "#002f4f"
  }
};


export default function AddTitlePage() {
  // const count = useSelector(state => state.counter.value)
  // const titleInStore = useSelector(state => state.project.title)
  const [title, setTitle] = React.useState('')
  const navigate = useNavigate();
  // const users = useSelector(state => state.user.data)
  
  const dispatch = useDispatch()

  // const setUsers = useCallback(async () => {
  //   await dispatch(fetchUsers())
  //   await dispatch(fetchPosts())
  // }, [dispatch])

  // const setTitleProject = useCallback(async () => {
  //   await dispatch(fetchUsers())
  //   await dispatch(fetchPosts())
  // }, [dispatch])
  

  const handleClickButton = () => {
    dispatch(addTitle(title))
    navigate("/choix-categorie", {replace: true});
  }

  return (
    <>
      <Grid container>
        <Grid item paddingTop={4} paddingLeft={2} paddingRight={2} xs={4} md={3} lg={2}>
          <Link to="/dashboard" style={styles.cssLink}>
            <CssBox>
              <Typography variant="subtitle2" style={styles.subtitleInput1}>Mes projets</Typography>
              <Typography variant="body2" style={styles.typoMenuLeft1}>Liste de mes projets</Typography>
            </CssBox>
          </Link>
        </Grid>
        <GridContentDashboard item container direction="column" xs={8} md={9} lg={10}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            marginTop={5}
            marginBottom={10}
          >
            <Box width="20%">
              <AddProjectStepper step={0} />
            </Box>
          </Grid>
          <Grid
            container
            direction="column"
            paddingLeft={5}
            marginTop={5}
            marginBottom={30}
          >
            <Typography variant="h4" style={styles.titleInput1}>
              Pour commencer
            </Typography>
            <Typography variant="body1" style={styles.subtitleInput1}>
              Ajouter un titre a votre projet
            </Typography>
            <Box marginTop={5}>
              <CssTextField
                helperText=" "
                id="demo-helper-text-aligned-no-helper"
                label="Titre du projet"
                size="small"
                onChange={(e) => setTitle(e.target.value)}
              />
            </Box>
          </Grid>

          <Grid container direction="row" justifyContent="center">
            <CssButton variant="contained" disabled={title.length === 0} onClick={() => handleClickButton()}>Continuer</CssButton>
          </Grid>
        </GridContentDashboard>
      </Grid>
    </>
  );
}
